import React from "react";
import { WSQueries } from "../../../query/WSQuery";
import { useUserId } from "../../../query/hooks/helpers";
import { useMemberProfile } from "../../../query/users/queries";
import { Form } from "./Form";
import { useMutationSubmit } from "./useMutationSubmit";

type Props = { onSuccess?: () => void };

export const FormManuallyAddInternationalAccount: React.FC<Props> = ({
  onSuccess
}) => {
  const userId = useUserId();
  const queryMember = useMemberProfile(userId);
  const [submit, submitMeta] = useMutationSubmit({
    onSuccess
  });

  return (
    <WSQueries queries={{ queryMember }}>
      {({ queryMember: { data: member } }) => (
        <Form
          onSubmit={data => {
            submit({ data });
          }}
          error={submitMeta.error}
          isLoading={submitMeta.isLoading}
          defaultValues={{
            country: member.profile.address?.country
          }}
        />
      )}
    </WSQueries>
  );
};
